import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import lock_img from "../../../assets/password.svg";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../../utils/confighelpers";
import { TwButton, TwInputGroup } from "../../../components/tailwind";
import { useTranslation } from "react-i18next";

export default function ChangePassword({
    onCancel
}) {
    const { t, i18n } = useTranslation();
    const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [formValues, setFormValues] = React.useState({
        password: "",
        repassword: "",
    });
    const [formErrors, setFormErrors] = React.useState({});
    const [passwordVisible, setPasswordVisible] = React.useState(false);
    const [repasswordVisible, setRepasswordVisible] = React.useState(false);
    const [isThereChange, setIsThereChange] = React.useState(true);
    const [userToken] = useLocalStorage("userToken");

    React.useEffect(() => {
        setTimeout(() => {
            setIsThereChange(true)
        }, 1 * 1000);
    }, [])
    React.useEffect(() => {
        setIsThereChange(false)
    }, [formValues])

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        dispatch(setActionLoading(true));

        const errors = {};
        if (!formValues.password) {
            errors.password = t("errors.required");
        } else if (formValues.password.length < 8) {
            errors.password = t("errors.passwordSyntax");
        }
        if (!formValues.repassword) {
            errors.repassword = t("errors.required");
        } else if (formValues.password !== formValues.repassword) {
            errors.repassword = t("errors.passwordNOTMatch");
        }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            dispatch(setActionLoading(false));
            addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
            return;
        }

        let body = {
            password: formValues.password,
        }
        dispatch(setGlobalLoading(true));
        const result = await axios.put(
            `${getUrlForUsers()}updateProfile`,
            {
                ...body,
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "x-access-token": userToken,
                },
            }
        );
        dispatch(setGlobalLoading(false));
        dispatch(setActionLoading(false));
        if (result.data.statusCode === 200) {
            addNotificationDialog({
                dialogType: "success",
                dialogTitle: t("successes.passwordSuccessfullyTitle"),
                dialogMessage: t("successes.passwordSuccessfullySubTitle"),
                dialogBtnTitle: t("inputFieldsTitle.ok"),
            })
            onCancel();
        } else {
            addErrorToast(result.data.message);
        }
    };

    return (
        <div className={"flex flex-col gap-4"}>
            <h2 className="text-base/7 font-semibold">{t("account.choosePasswordTitle")}</h2>
            <TwInputGroup
                label={t("inputFieldsTitle.password")}
                placeholder={t("inputFieldsTitle.passwordPlaceholder")}
                name={"password"}
                type={passwordVisible ? "text" : "password"}
                leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                rightIcon={
                    passwordVisible ? (
                        <EyeIcon onClick={() => setPasswordVisible(!passwordVisible)} />
                    ) : (
                        <EyeSlashIcon onClick={() => setPasswordVisible(!passwordVisible)} />
                    )
                }
                onChange={handleInputChange}
                errors={formErrors}
            />
            <TwInputGroup
                label={t("inputFieldsTitle.rePasswordPlaceholder")}
                placeholder={t("inputFieldsTitle.rePasswordPlaceholder")}
                name={"repassword"}
                type={repasswordVisible ? "text" : "password"}
                leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                rightIcon={
                    repasswordVisible ? (
                        <EyeIcon onClick={() => setRepasswordVisible(!repasswordVisible)} />
                    ) : (
                        <EyeSlashIcon onClick={() => setRepasswordVisible(!repasswordVisible)} />
                    )
                }
                onChange={handleInputChange}
                errors={formErrors}
            />
            <div className={"flex flex-row items-center gap-2"}>
                <TwButton
                    variant={"danger-outline"}
                    className="sm:min-w-32"
                    disabled={loadingReduxState.actionLoading}
                    onClick={() => {
                        onCancel()
                    }}
                >
                    {t("inputFieldsTitle.cancel")}
                </TwButton>
                <TwButton
                    variant={"danger"}
                    className="sm:min-w-32"
                    actionLoading={(loadingReduxState.actionLoading)}
                    disabled={loadingReduxState.actionLoading || isThereChange}
                    onClick={handleSubmit}
                >
                    {t("inputFieldsTitle.updatePassword")}
                </TwButton>
            </div>
        </div>
    );
}
